import { useQuery } from "@apollo/client";
import type { Offering } from "@casey/db-types";
import { GET_OFFERING_BY_ID } from "../gql";

interface OfferingVariables {
  id: string;
}

interface OfferingResponse {
  offering: Offering;
}

export function useOffering(id: string) {
  const { data, loading, error, refetch } = useQuery<
    OfferingResponse,
    OfferingVariables
  >(GET_OFFERING_BY_ID, {
    variables: { id },
    skip: !id,
    errorPolicy: "all",
  });

  return {
    offering: data?.offering || null,
    loading,
    error,
    refetch,
  };
}
